// Dana compose-assist — proofread / rewrite the current draft via ai-agent's chat
// endpoint (no conversation side effects; a pure text call). Nothing sends here; the
// user chooses whether to use a suggestion.
import { aiChat } from '@/lib/hrApi';

export type AssistTone = 'improve' | 'formal' | 'shorter';

const INSTRUCTION: Record<AssistTone, string> = {
  improve:
    'Proofread and improve this workplace chat message. Fix grammar, spelling and clarity while keeping the meaning and a natural, friendly tone.',
  formal: 'Rewrite this workplace chat message to be more professional and polite, keeping the meaning.',
  shorter: 'Make this workplace chat message shorter and clearer without losing its meaning.',
};

/** Returns a rewritten version of `draft` in the requested tone. Throws on failure. */
export async function assistDraft(tone: AssistTone, draft: string): Promise<string> {
  const res = await aiChat(
    `${INSTRUCTION[tone]} Return ONLY the rewritten message — no quotes, labels, options, or preamble.\n\nMessage:\n${draft.trim()}`,
  );
  return (res?.reply ?? '').trim().replace(/^["']+|["']+$/g, '');
}
